// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".YoutubeCard__video___kMhM_{border-radius:8px}.YoutubeCard__container___1jfH3{display:flex;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"video": "YoutubeCard__video___kMhM_",
	"container": "YoutubeCard__container___1jfH3"
};
module.exports = ___CSS_LOADER_EXPORT___;
